import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {DynamicCurrencyInput} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicCurrencyInput';

export {DynamicCurrencyInput};
export default connectDynamic(DynamicCurrencyInput);
